import { getPublicAuthHeader, getReturnWidgetFetchClient } from "./return-widget-client";

export type ValidateCarrierResponse = {
  code: string;
};

export async function publicValidateCarrier(body: unknown): Promise<ValidateCarrierResponse> {
  const { data, error } = await getReturnWidgetFetchClient().POST(
    "/public/return-request/validate-carrier",
    { params: { header: getPublicAuthHeader() }, body: body as never },
  );
  if (error) throw error;
  return data as ValidateCarrierResponse;
}
